import React from "react";

function Switch(props) {
  const { test, children } = props;
  // Filter out only children with a matching prop
  return children.find((child) => {
    return child.props.condition === test;
  });
}
export default Switch;
